import { render } from "./gsrcu0101.vue?vue&type=template&id=b5809354&scoped=true"
import script from "./gsrcu0101.vue?vue&type=script&lang=js"
export * from "./gsrcu0101.vue?vue&type=script&lang=js"

import "./gsrcu0101.vue?vue&type=style&index=0&id=b5809354&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5809354"]])

export default __exports__